module.exports = "/static-assets/_next/static/images/privacy-policy-60c801f0c4d68982c9a744ec31571204.png";